import React from 'react'
import cn from 'classnames'

import '../../styles/blocks/overlay.scss'

const Overlay = ({ className, children }) => <div className={cn('overlay', className)}>{children}</div>

export default Overlay
